<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <SubHeaderWithSidebar :title="headerTitle" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="quizWrap result">
            <h5 class="subtitle">
              Quiz
              <span>{{itemIndex}}</span>
            </h5>
            <!-- 텍스트 만 있을경우  -->
            <div class="quiz first answer" style="display: block;">
              <div class="resultWrap">
                <div class="icon">
                  <img :src="feedback_img" alt="정답입니다." />
                </div>
                <h4>{{feedback_text}}</h4>
              </div>

              <div :class="bogiStyle">
                <div :class="bogi.style" v-bind:key="bogi.id" v-for="bogi in bogis">
                  <input type="checkbox" :id="bogi.kid" v-model="bogi.checked" />
                  <label :for="bogi.kid">
                    <div class="num">{{bogi.index}}</div>
                    <div class="text" v-if="bogi.title != null">{{bogi.title}}</div>
                    <div class="img">
                      <img :src="bogi.image.url" v-if="bogi.image != null" />
                    </div>
                  </label>
                </div>
                <div class="example empty" v-if="odd">
                  <div class="empty">
                    <img src="@/assets/img/ex_logo.png" alt="빈칸" />
                  </div>
                </div>
              </div>
              <!-- exampleWrap -->
            </div>
            <!-- quiz -->
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar },
  computed: {
    feedback_img() {
      let is_correct = this.$store.state.itemMeta.is_correct;
      if (is_correct) {
        return require("@/assets/img/answer.png");
      } else {
        return require("@/assets/img/w_answer.png");
      }
    },
    feedback_text() {
      let is_correct = this.$store.state.itemMeta.is_correct;
      return is_correct ? "정답 입니다!" : "오답 입니다!";
    },
    bogiStyle() {
      let bogi_deco = this.$store.state.itemMeta.bogi_deco;
      return bogi_deco === "text" ? "exampleWrap text_ex" : "exampleWrap";
    },
    bogis() {
      let details = this.$store.state.itemMeta.details;
      // console.log(this.$store.state.itemMeta);
      let my_answers = this.$store.state.itemMeta.my_answers;

      my_answers = [...my_answers];

      let answer = this.$store.state.itemMeta.answer;
      details.forEach((item, index) => {
        item.kid = "example1_" + (index + 1);
        item.style = "example"; // example , example checked
        item.checked = false;

        for (var i = 0; i < my_answers.length; i++) {
          if (item.id === my_answers[i]) {
            item.style += " checked";
            item.checked = true;
            break;
          }
        }

        for (var i = 0; i < answer.length; i++) {
          if (item.id === answer[i]) {
            // alert("origanl answer  catch:" + item.id);
            item.style += " answer";

            break;
          }
        }

        // item.style = "example answer";
        // item.style = "example"; // example , example checked
      });

      console.log(details);

      return details;
    },
    odd() {
      let bogi_deco = this.$store.state.itemMeta.bogi_deco;
      let details = this.$store.getters.getItemMeta.details;
      return details.length % 2 === 0 || bogi_deco === "text" ? false : true;
    },
    itemIndex() {
      return this.$store.state.itemMeta.index;
    },
    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    }
  },
  methods: {
    dummy() {}
  }
};
</script>


<style lang="scss" scoped>
</style>